/**
/**
 * @description Theme skin enum that defines the available visual styling variants for the application.
 * Different skins provide different approaches to borders, shadows, and overall visual hierarchy.
 * ```
 */
export enum ThemeSkin {
    /**
     * @description Default skin variant with minimal borders and subtle styling.
     * This skin provides a clean, modern appearance with focus on content.
     */
    Default = 'default',
    
    /**
     * @description Bordered skin variant with defined borders and clear visual separation.
     * This skin provides a structured, organized appearance with clear component boundaries.
     */
    Bordered = 'bordered',
}

/**
 * @description Union type for theme skin that accepts both enum values and string literals.
 * This provides flexibility when working with theme skin values while maintaining type safety.
 */
export type ThemeSkinType = 'default' | 'bordered';

/**
 * @description Union type for theme skin that accepts both enum values and string literals.
 * This is an alias for ThemeSkinType and provides backward compatibility.
 */
export type IThemeSkin = ThemeSkin | ThemeSkinType;